/* eslint-disable no-restricted-syntax */
type TemplateVariable = string | { name?: string; value?: string };

export function replaceTemplateVariables(
  text: string,
  variables?: TemplateVariable[],
) {
  if (!variables?.length) {
    return text;
  }

  const variableMap = new Map<string, string>();

  for (const [index, variable] of variables.entries()) {
    const value =
      typeof variable === 'string'
        ? variable.trim()
        : variable?.value?.trim() || '';

    variableMap.set(String(index + 1), value);

    if (typeof variable !== 'string' && variable?.name) {
      const cleanName = variable.name.replaceAll(/{{\s*|\s*}}/g, '').trim();

      variableMap.set(cleanName, value);
    }
  }

  return text.replaceAll(/{{\s*([^}]+)\s*}}/g, (_, rawKey) => {
    const key = rawKey.trim();

    if (variableMap.has(key)) {
      const value = variableMap.get(key);

      return value && value.length > 0 ? value : `{{${key}}}`;
    }

    return `{{${key}}}`;
  });
}
